import { createEntityFilterConfig } from '../../factories/create-entity-filter-config';
import { STATIC_FILTER_ENTITY_TYPES } from '@shared/features/views/components/entities-filters/config';
import { partnersApi } from '@src/features/users/services/partners-api';
import { PartnerFilterOptionItem } from './filter-option-item';
import { FILTER_COLOR } from '../filter-colors';

export const partnerFilterConfig = createEntityFilterConfig({
  entityType: STATIC_FILTER_ENTITY_TYPES.partner,
  facetName: 'partner',
  fetchInfiniteData: partnersApi.useFetchInfinite,
  getValue: (item) => String(item.id),
  renderItem: PartnerFilterOptionItem,
  color: FILTER_COLOR.orange,
});
